import { MODELER_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  Error,
  GetTestCasesParams,
  GetTestCasesResponse
} from '@eggplant/types'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'

interface Props {
  params?: GetTestCasesParams
  onSuccess?: (response: GetTestCasesResponse) => void
  onError?: (error: Error) => void
  children?: (data: GetTestCasesResponse) => React.ReactNode
}

const GetModelerTestCasesRequest = ({
  params,
  onSuccess,
  onError,
  children
}: Props) => {
  const url = `${MODELER_SERVICE}/test_cases`

  const { requestParams } = useGetParamsWithSpaceId<GetTestCasesParams | undefined>(params)

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={requestParams}
      url={url}
    />
  )
}

export default GetModelerTestCasesRequest
